export default {
  platformName: "Teacher Platform",
  updatePswd: "Change Password",
  logout: "Sign Out",
  bindWxTip: "Please scan code to bind wechat !",
  confirmLogout: "Are you sure you want to sign out ?",
  changePswdSuc: "Password modified successfully ！",
  selectPlaceholder: "Please select",
  cancel: "Cancel",
  mobile: "Mobile",
  oldPswd: "Old Password",
  newPswd: "New Password",
  confirmPswd: "Confirm Password",
  confirmPswdErrTip: "The passwords entered twice are inconsistent !",
  pswdRule: "Character length 6-20, no less than 6, no more than 20 !",
  phoneRequired: "Please enter your phone number .",
  oldPswdRequired: "Please enter the old password  .",
  newPswdRequired: "Please enter a new password  .",
  confirmPswdRequired: "Please enter 'Confirm Password' .",
  yes: "yes",
  no: "no",
  back: "Back",
  user: {
    user: "User",
    nickName: "User nickname",
    userId: "User ID",
    starRating: "Star rating"
  },
  confirm: "Confirm",
  reply: "Reply",
  replyReuired: "Please enter the reply content !",
  teacher: "Teacher",
  ok: "Got it",
  optTip: "Operating tips",
  add: "Add",
  remark: "Remark"
};



// WEBPACK FOOTER //
// ./src/i18n/en-US/global.js